import { DEFAULT } from '../config'
import { getFromLocalStorage, hasItemExpired, saveToLocalStorage, saveToLocalStorageWithMeta } from '../utils/common'
// import { jwtDecode } from "jwt-decode"



export const handleFetchFilters = () => {
    
    return async dispatch => {
        
        return await DEFAULT.axios.get(`${DEFAULT.api}/api/filters`)
            .then( res => {
                const data = res.data.data
                dispatch(handleSetFilters(data))
            })
    }
}

export const handleSetFilters = (filters) => {
    const filtersNotAllowed = [
        "Backlight",
        "Raqueta",
        "Vinil",
        "Pendones",
        "Espacio de activación",
        "Póster",
        "Poster",
        "Aire acondicionado",
        "Bastidor Espectacular",
        "Pasarela",
        "Letrero en fachada",
    ]
    const uniqueTypes = new Set();
    const filteredTypes = [];
    
    // filteredTypes.push({ name: "Espectacular" });
    // uniqueTypes.add("Espectacular");
    
    filters.type.forEach(type => {
        if (!filtersNotAllowed.includes(type.original) && !uniqueTypes.has(type.original)) {
            filteredTypes.push(type);
            uniqueTypes.add(type.original);
        }
    });
    
    filters.type = filteredTypes;
    return {
        type: "HANDLE_SET_FILTERS",
        payload: filters
    }
}

const PARALLEL_PAGE_CHUNK = 5

const fetchMediaPage = (country, page, etag) => {
    const headers = etag ? { 'If-None-Match': etag } : {}
    return DEFAULT.axios.get(`${DEFAULT.api}/api/media/country/${country}?page=${page}`, { headers, validateStatus: s => s === 200 || s === 304 })
}

const hashMediaIds = (media) => {
    if (!media || media.length === 0) return ''
    let h = 0
    for (let i = 0; i < media.length; i++) {
        const id = media[i].id || 0
        h = ((h << 5) - h + id) | 0
    }
    return `${media.length}:${h}`
}

export const handleFetchMedia = (country) => {
    return async dispatch => {
        dispatch(handleSetLoading(true))
        dispatch(handleSetFetchProgress({ loaded: 0, total: 0 }))

        const cacheKey = `media_${country}`
        const cached = await getFromLocalStorage(cacheKey)
        const cacheIsFresh = cached ? !(await hasItemExpired(cacheKey)) : false

        if (cached && cached.data) {
            dispatch(handleSetMedia(cached.data))
            if (cacheIsFresh) {
                dispatch(handleSetLoading(false))
                return
            }
        }

        try {
            const cachedEtag = cached && cached.etag ? cached.etag : null
            const firstRes = await fetchMediaPage(country, 1, cachedEtag)

            if (firstRes.status === 304) {
                dispatch(handleSetLoading(false))
                return
            }

            const firstData = firstRes.data.data
            const pagination = firstRes.data.pagination
            const lastPage = pagination.last_page
            const responseEtag = firstRes.headers && firstRes.headers.etag ? firstRes.headers.etag : null

            dispatch(handleSetFetchProgress({ loaded: 1, total: lastPage }))

            let media = firstData

            if (lastPage > 1) {
                const remaining = []
                for (let p = 2; p <= lastPage; p++) remaining.push(p)

                const pageResults = new Array(lastPage)
                pageResults[0] = firstData

                let loaded = 1
                for (let i = 0; i < remaining.length; i += PARALLEL_PAGE_CHUNK) {
                    const chunk = remaining.slice(i, i + PARALLEL_PAGE_CHUNK)
                    const responses = await Promise.all(chunk.map(p => fetchMediaPage(country, p)))
                    responses.forEach((res, idx) => {
                        pageResults[chunk[idx] - 1] = res.data.data
                        loaded += 1
                    })
                    dispatch(handleSetFetchProgress({ loaded, total: lastPage }))
                }

                media = pageResults.reduce((acc, p) => acc.concat(p || []), [])
            }

            const nextHash = hashMediaIds(media)
            const cachedHash = cached && cached.data ? hashMediaIds(cached.data) : ''
            if (!cached || nextHash !== cachedHash) {
                dispatch(handleSetMedia(media))
            }
            saveToLocalStorageWithMeta(cacheKey, media, responseEtag)
        } catch (error) {
            console.error("Error fetching media:", error)
        } finally {
            dispatch(handleSetFetchProgress({ loaded: 0, total: 0 }))
            dispatch(handleSetLoading(false))
        }
    }
}

export const handleSetMap = (map) => {
    return {
        type: "HANDLE_SET_MAP",
        payload: map
    }
}

export const handleSetLoading = (loading) => {
    return {
        type: "HANDLE_SET_LOADING",
        payload: loading
    }
}

export const handleSetMedia = (media) => {
    return {
        type: "HANDLE_SET_MEDIA",
        payload: media
    }
}

export const handleSetMarkers = (markers) => {
    return {
        type: "HANDLE_SET_MARKERS",
        payload: markers
    }
}

export const handleSetMapCircle = (circle) => {
    return {
        type: "HANDLE_SET_MAP_CIRCLE",
        payload: circle
    }
}

export const handleSetMapCircleBatch = (circles) => {
    return {
        type: "HANDLE_SET_MAP_CIRCLE_BATCH",
        payload: circles
    }
}

export const handleSetFetchProgress = (progress) => {
    return {
        type: "HANDLE_SET_FETCH_PROGRESS",
        payload: progress
    }
}

export const handleSetPointsOfInterest = (pointsOfInterest, index) => {
    return {
        type: "HANDLE_SET_POINTS_OF_INTEREST",
        index: index,
        payload: pointsOfInterest
    }
}

export const handleRemovePointOfInterest = (index) => {
    return {
        type: "HANDLE_REMOVE_POINTS_OF_INTEREST",
        removeItem: index
    }
}

export const handleSetMarkerClusterer = (markerClusterer) => {
    return {
        type: "HANDLE_SET_MARKER_CLUSTERER",
        payload: markerClusterer
    }
}

export const handleSetFavoriteMedium = (medium) => {
    return {
        type: "HANDLE_SET_FAVORITE_MEDIA",
        newItem: medium
    }
}

export const handleRemoveFavoriteMedium = (medium) => {
    return {
        type: "HANDLE_REMOVE_FAVORITE_MEDIA",
        removeItem: medium
    }
}

export const handleFilterMedia = (filter) => {
    return {
        type: "HANDLE_FILTER_MEDIA",
        filter: filter
    }
}

export const handleShowMediaModal = (show) => {
    return {
        type: "HANDLE_SHOW_MEDIA_MODAL",
        show: show
    }
}

export const handleShowContactModal = (show) => {
    return {
        type: "HANDLE_SHOW_CONTACT_MODAL",
        show: show
    }
}

export const handleSetCurrentMedium = (medium) => {
    return async (dispatch) => {
        try {
            if (medium){
                const { id } = medium;
                const response = await DEFAULT.axios.get(`${DEFAULT.api}/api/media/show/${id}`);
                const fullMedium = response.data.data;
    
                dispatch({
                    type: "HANDLE_SET_CURRENT_MEDIUM",
                    medium: fullMedium,
                });
            } else {
                dispatch({
                    type: "HANDLE_SET_CURRENT_MEDIUM",
                    medium: null,
                });
            }
        } catch (error) {
            console.error("Error fetching medium:", error);
            dispatch({
                type: "HANDLE_SET_CURRENT_MEDIUM",
                medium: null,
            });
        }
    };
}

export const handleRandomizeExecutive = () => {
    return {
        type: "HANDLE_RANDOMIZE_EXECUTIVE",
    }
}

export const handleSetCountry = (country) => {
    return {
        type: "HANDLE_SET_COUNTRY",
        country: country
    }
}

export const handleSetViewOnlyFavoriteList= (viewOnlyFavoriteList) => {
    return {
        type: "HANDLE_SET_VIEW_ONLY_FAVORITE_LIST",
        viewOnlyFavoriteList: viewOnlyFavoriteList
    }
}

export const handleFetchMedium = (code) => {
    return async () => {
        return await DEFAULT.axios.get(`${DEFAULT.api}/api/media/${code}`)
            .then( res => {
                const data = res.data.data
                return data
            })
    }
}

export const handleFetchMediaByCodes = (codes) => {
    return async (dispatch) => {
        try {
            console.log(codes);
            const media = await Promise.all(
                codes.map(async code => 
                    (await DEFAULT.axios.get(`${DEFAULT.api}/api/media/${code}`)).data.data
                )
            );
            console.log(media);
            dispatch(handleSetMedia(media));
        } catch (error) {
            console.error("Error fetching media:", error);
            dispatch(handleSetMedia([]));
        }
    };
};

